module.exports = __webpack_public_path__ + "img/instruction.acc21557.jpg";